import { CircleFadingArrowUp, X } from "lucide-react";
import Button from "../Button/Button";
import Typography from "../Typography/Typography";
import { useState, useEffect } from "react";
import { useAuth } from "../../store/AuthContext/AuthContext";
import { getCountdownFrom72Hours } from "../../utils/timeUtils";

export default function SidePayWall({ onClick }) {
    const { isSubbed, userCreatedAt } = useAuth();
    const [isVisible, setIsVisible] = useState(false);
    const [timer, setTimer] = useState(getCountdownFrom72Hours(userCreatedAt));

    useEffect(() => {
        if (isSubbed === true) {
            setIsVisible(false);
        } else {
            setIsVisible(true);
        }
    }, [isSubbed]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(getCountdownFrom72Hours(userCreatedAt));
        }, 1000);

        return () => clearInterval(interval); // pulizia
    }, [userCreatedAt]);

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        timer && (
            <div className="flex flex-col bg-white rounded-[12px] p-3 gap-4 relative" onClick={onClick}>
                <div className="flex flex-col gap-2">
                    <img src="/assets/images/illustrations/FastInternet.png" alt="Upgrade" className="hidden lg:block max-h-40 object-contain" />
                    <Typography size="16" weight="sb" align="center">
                        Il regalo di benvenuto scade tra {timer}
                    </Typography>
                </div>
                <Button licon={<CircleFadingArrowUp size={16} />} text="Fai l’upgrade!" size="sm" type="color" width="full" />
                <div className="absolute right-0 top-0 p-3 cursor-pointer text-gray-600" onClick={handleClose}>
                    <X size="16" />
                </div>
            </div>
        )
    );
};
